import { useState, useEffect } from "react";
import "./Settings.css";
import axios from "axios";


const Settings = () => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [settings, setSettings] = useState({
    enableAll: false,
    offers: false,
    orders: false,
    whatsapp: false,
  });

  // Toggle Dropdowns
  const toggleDropdown = (section) => {
    setOpenDropdown(openDropdown === section ? null : section);
  };

  useEffect(() => {
    const fetchUserProfile = async () => {
      const userId = localStorage.getItem("userId");
      if (!userId) {
        console.error("User ID not found in localStorage");
        return;
      }

      setLoading(true);
      try {
        const response = await axios.get(
          `https://backend.maamaas.com/food/user/getprofile/${userId}`
        );
        setUserData(response.data);
      } catch (error) {
        console.error("Error fetching user profile:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, []);


  // Toggle Switches
  const toggleSetting = (key) => {
    setSettings((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <div style={{ marginTop: "35px" }}>

      {/* Notifications & Preferences Section */}
      <button onClick={() => toggleDropdown("notifications")} className="dropdown-button" style={{ height: "50px" }}>
        <p style={{ marginTop: "-10px" }}>  Notifications & Preferences {openDropdown === "notifications" ? "▲" : "▼"}</p>
      </button>
      {openDropdown === "notifications" && (
        <div className="dropdown-content">
          <ul style={{ fontSize: "20px" }}>
            <li>
              Enable All
              <input type="checkbox" checked={settings.enableAll} onChange={() => toggleSetting("enableAll")} />
            </li>
            <li>
              Offers and Coupons
              <input type="checkbox" checked={settings.offers} onChange={() => toggleSetting("offers")} />
            </li>
            <li>
              Order and Purchases
              <input type="checkbox" checked={settings.orders} onChange={() => toggleSetting("orders")} />
            </li>
            <li>
              WhatsApp
              <input type="checkbox" checked={settings.whatsapp} onChange={() => toggleSetting("whatsapp")} />
            </li>
          </ul>
        </div>
      )}

      {/* General Info Section */}
      <button
        onClick={() => toggleDropdown("generalInfo")}
        className="dropdown-button"
        style={{ height: "50px" }}
      >
        <p style={{ marginTop: "-10px" }}>
          General Info {openDropdown === "generalInfo" ? "▲" : "▼"}
        </p>
      </button>

      {openDropdown === "generalInfo" && (
        <div className="dropdown-content">
          {loading ? (
            <p>Loading...</p>
          ) : userData ? (
            <ul style={{ fontSize: "20px" }}>
              <li>Name: {userData.userName}</li>
              <li>Email: {userData.emailId}</li>
              <li>Phone: {userData.mobileNumber}</li>
            </ul>
          ) : (
            <p>No data available</p>
          )}
        </div>
      )}
      <div
        style={{
          position: "fixed",
          bottom: "0px",
          left: "0px",
          height: '30px',
          width: "100%",
          backgroundColor: "white",
          color: "black",
          textAlign: "center",
          padding: "5px",
          fontWeight: "bold",
          fontSize: "14px",
          boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.1)",
          zIndex: "999"
        }}
      >
        @Envision Integrated Services Pvt Ltd - Empowering Your Future 🚀
      </div>
    </div>
  );
};

export default Settings;
